import { useSetAtom } from 'jotai';

import {
  $confirmLoadReconciliationFile,
  $createLoadReconciliationFile,
  $deleteLoadReconciliationFile,
} from '~/modules/trade/_state/loadReconciliation.state';
import { FileMutations } from '~/modules/trade/types/file';

export const useReceivingTicketFiles = (): FileMutations => {
  const createFile = useSetAtom($createLoadReconciliationFile);
  const confirmFileUpload = useSetAtom($confirmLoadReconciliationFile);
  const deleteFile = useSetAtom($deleteLoadReconciliationFile);

  return {
    createFile: async (params) => {
      const result = await createFile({
        fileName: params.fileName,
        mimeType: params.mimeType,
        reconciliationId: params.entityId,
        fileSize: params.fileSize,
      });

      return {
        id: result.tradeLoadReconciliationFileCreate.file.id,
        uploadUrl: result.tradeLoadReconciliationFileCreate.uploadUrl ?? '',
      };
    },
    confirmUpload: async (params) => {
      const _result = await confirmFileUpload({ fileId: params.fileId });

      return {
        url: '', // No download URL available from confirm upload, will use download hook when needed
      };
    },
    deleteFile: async (params) => {
      await deleteFile({ fileId: params.fileId });
    },
  };
};
